
import axios from 'axios'
import config from './isLocalDev'



let options = {
baseURL: config.baseURL,
timeout: 10000,
headers: {
'Content-Type': 'application/json; charset=utf-8',
}
};
const Axios = axios.create(options);

Axios.interceptors.request.use((config) => {
console.log('输出axios拦截信息:', config);

return config
}, (error) => {
console.log(error);
if (error && error.response) {
console.log(error.response);
console.log(error.response.status)
}
return Promise.reject('error')
});

Axios.interceptors.response.use(function (response) {
if (!response) {
return Promise.reject('error')
}
return response;
}, function (error) {

console.log(error);
console.log('response:' + error.response);
if (error && error.response) {
if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
console.log("错误回调", error);

alert("网络超时");
context.$router.push("/");
return Promise.reject(error);          
}
console.log(error.response);
console.log(error.response.status);























































}
return Promise.reject(error);
});




export default axios



// WEBPACK FOOTER //
// ./src/api/axiosplugin.js